import {
    RichTableColumns,
} from 'app/types/richtable.types'
import {
    ProductType,
    OrderModificationReason,
} from 'app/enums/label.enums'

import {
    RequiredContainersChangeType,
} from '../../longTermLease.types'

const getColumns = (
    l: (l: string) => string,
): RichTableColumns<keyof RequiredContainersChangeType>[] => {
    return [
        {
            id: 'modificationReason',
            headerProps: {
                children: l('LaneFees.rejectedReason'),
            },
            mapCellProps: 'modificationReason',
            componentName: 'EnumValue',
            allowedValuesEnum: OrderModificationReason,
        },
        {
            id: 'modifiedBy',
            headerProps: {
                children: l('Prebooking.modifiedBy'),
            },
            mapCellProps: 'modifiedBy',
        },
        {
            id: 'modifiedOn',
            headerProps: {
                children: l('Prebooking.modifiedOn'),
            },
            mapCellProps: 'modifiedOn',
        },
        {
            id: 'previousRequiredContainers',
            headerProps: {
                children: l('RequiredContainersChange.previousValue'),
            },
            componentName: 'RequiredContainersList',
            allowedValuesEnum: ProductType,
            mapCellProps: 'previousRequiredContainers',
        },
        {
            id: 'requiredContainers',
            headerProps: {
                children: l('CurrentMonthForecastUpdate.updatedValue'),
            },
            componentName: 'RequiredContainersList',
            allowedValuesEnum: ProductType,
            mapCellProps: 'requiredContainers',
        },
        {
            id: 'modificationComment',
            headerProps: {
                children: l('OrderByNumberView.modificationComment'),
            },
            mapCellProps: 'modificationComment',
        },
    ]
}

export default getColumns
